

































































import { Vue, Component, Inject } from "vue-property-decorator";
import {
  IOrderTemplatesProviderData,
  IOrderTemplatesProviderMethods
} from "@/models/providers/orderTemplates";

@Component({
  components: {
    "order-template-list-item": () =>
      import(
        "@/components/app/admin/settings/orderTemplates/orderTemplateListItem.vue"
      )
  }
})
export default class OrderTemplatesTable extends Vue {
  // Inject

  @Inject({ from: "orderTemplatesProviderData" })
  public readonly $orderTemplatesProvider!: () => IOrderTemplatesProviderData;

  @Inject({ from: "orderTemplatesProviderMethods" })
  public readonly $orderTemplatesMethods!: IOrderTemplatesProviderMethods;

  // Computed

  public get $otd() {
    return this.$orderTemplatesProvider();
  }

  public get skeletonSize() {
    return this.$otd.table.total || this.$store.getters["ui/isMobile"] ? 2 : 6;
  }
}
